import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const routes = [
  {
    from: "Dubai",
    to: "Bangkok",
    fromCode: "DXB",
    toCode: "BKK",
    image: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=200&q=80",
  },
  {
    from: "Singapore",
    to: "Dubai",
    fromCode: "SIN",
    toCode: "DXB",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=200&q=80",
  },
  {
    from: "Bangkok",
    to: "Singapore",
    fromCode: "BKK",
    toCode: "SIN",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=200&q=80",
  },
  {
    from: "Dubai",
    to: "Doha",
    fromCode: "DXB",
    toCode: "DOH",
    image: "https://images.unsplash.com/photo-1529074963764-98f45c47344b?auto=format&fit=crop&w=1600&q=80",
  },
  {
    from: "Kathmandu",
    to: "Bangkok",
    fromCode: "KTM",
    toCode: "BKK",
    image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=200&q=80",
  },
  {
    from: "Colombo",
    to: "Singapore",
    fromCode: "CMB",
    toCode: "SIN",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1600&q=80",
  },
  {
    from: "Dubai",
    to: "London",
    fromCode: "DXB",
    toCode: "LHR",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=200&q=80",
  },
  {
    from: "Doha",
    to: "Bangkok",
    fromCode: "DOH",
    toCode: "BKK",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1600&q=80",
  },
];

const today = new Date().toISOString().split("T")[0];
export default function TrendingRoutes() {
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate(); // ✅ Yahan hona chahiye

 const handleSearch = (route) => {

  const payload = {
    APIToken: null,
    AgencyKey: "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
    AdultCount: 1,
    ChildCount: 0,
    InfantCount: 0,
    PreferredAirlines: null,
    Routs: [
      {
        Source: route.fromCode,
        Destination: route.toCode,
        TravelDate: today
      }
    ],
    TripType: 0,
    TypeOfClass: 0,
    IsDomestic: true,
    IsB2B: false,
    AccountNo: 11
  };

  const queryParams = new URLSearchParams({
    origin: route.fromCode,
    destination: route.toCode,
    date: today,
    trip: "O"
  }).toString();

  navigate(`/AirResponse/Index?${queryParams}`, {
    state: { searchData: payload }
  });
};

  return (
    <section style={{ padding: "2.5rem 1.5rem", background: "#f8f9fb" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        {/* Title */}
        <h2 style={{
          fontSize: 26,
          fontWeight: 700,
          color: "#0a2a6e",
          marginBottom: "1.8rem",
        }}>
          <span style={{ fontWeight: 700 }}>Trending</span>{" "}
          <span style={{ fontWeight: 400, color: "#4a5568" }}>Routes</span>
        </h2>

        {/* Grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: 16,
        }}>
          {routes.map((route, i) => (
            <div
              key={i}
              onClick={() => handleSearch(route)}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                background: "#f6fcff",
                borderRadius: 12,
                border: hovered === i
                  ? "1.5px solid #b0c4de"
                  : "1px solid #e2e8f0",
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: hovered === i
                  ? "0 4px 16px rgba(24,95,165,0.10)"
                  : "0 1px 4px rgba(0,0,0,0.05)",
                transition: "box-shadow 0.18s ease, border 0.18s ease",
                minHeight: 88,
              }}
            >
              {/* Image */}
              <div style={{
                width: 100,
                minWidth: 100,
                height: 88,
                overflow: "hidden",
                flexShrink: 0,
              }}>
                <img
                  src={route.image}
                  alt={route.to}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    transform: hovered === i ? "scale(1.07)" : "scale(1)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>

              {/* Text */}
              <div style={{ padding: "10px 14px", flex: 1 }}>
                {/* Route Name */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13.5,
                  fontWeight: 600,
                  color: "#1a202c",
                  marginBottom: 5,
                  whiteSpace: "nowrap",
                }}>
                  <span>{route.from}</span>
                  <span style={{ fontSize: 15 }}>✈</span>
                  <span>{route.to}</span>
                </div>

                {/* Airport Codes */}
                <div style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#e53e3e",
                  marginBottom: 5,
                  letterSpacing: 0.3,
                }}>
                  {route.fromCode}{" "}
                  <span style={{ fontWeight: 400, color: "#e53e3e" }}>→</span>{" "}
                  {route.toCode}
                </div>

                {/* Date */}
                <div style={{
                  fontSize: 12,
                  color: "#718096",
                }}>
                  {today}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
